import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

export default function Paywall() {
  return (
    <div className="max-w-3xl mx-auto my-10 relative" data-testid="paywall">
      <div className="absolute -top-24 left-0 right-0 h-24 pointer-events-none bg-gradient-to-b from-transparent to-[color:var(--bg)]" />
      <div className="border-2 p-8 md:p-12 text-center bg-[color:var(--surface)]" style={{ borderColor: "var(--accent)" }}>
        <Lock className="mx-auto text-[color:var(--accent)]" size={36} />
        <div className="kicker text-[color:var(--accent)] mt-4 mb-2">Subscribers only</div>
        <h3 className="font-serif text-3xl md:text-4xl font-bold leading-tight tracking-tight">
          Keep reading Julia Fosah&apos;s Weekly Long Read
        </h3>
        <p className="mt-4 text-[color:var(--text-muted)] max-w-lg mx-auto">
          $5 a month unlocks the full essay, the premium archive, and every future long read. Cancel anytime.
        </p>
        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <Link to="/subscribe" className="btn-accent" data-testid="paywall-subscribe">Subscribe for $5/month</Link>
          <Link to="/" className="btn-outline">Read the free stories</Link>
        </div>
      </div>
    </div>
  );
}
